import React, { useEffect, useState } from "react";
import Layout from "../../layouts/Layout";
import Hopital from "../../components/icons/hopital";
import Factory from "../../components/icons/icon-factory";
import { useSearchParams } from 'react-router-dom';
import { Label } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import apiService from '../../utils/api.service';
import _ from 'lodash'
import { connect } from "react-redux";
import actions from "../../redux/actions";
import helper from "../../utils/helper";

const HospitalListDef = [
  { type: "H", name: "โรงพยาบาล Prince" },
  { type: "F", name: "โรงงาน xxxxx" },
  { type: "F", name: "โรงงาน xxxxx" },
];

const ScheduleStep2 = (props) => {
  const [HospitalList, setHospitalList] = useState([]);
  const [searchParams] = useSearchParams();
  const queryDate = searchParams.get('date')
  let navigate = useNavigate();

  const selecthospital = (e) => {
    console.log('selecthospital >>', e)
    navigate(`/schedule-step3?&hospitalId=${e.hospitalId}&hospitalName=${e.hospitalName || ''}`);
  }

  useEffect( () => {
    SearchHospital()
  }, [])
  async function SearchHospital() {
    try {
      const header = helper.GEN.toValueHeader(props)
      const { resData } = await apiService.BookShift.SearchHospital({ date: queryDate, memberId: props.user?.lineId?.memberId }, header)
      let _HospitalList = _.cloneDeep(HospitalList)
      if(resData.resultCode === "20000"){
        _HospitalList = resData.data.map( item => ({ ...item, type: item.status == 1 ? 'H' : 'F', name: item.hospitalName , }))
        setHospitalList(_HospitalList)
      }
    }
    catch(e){
      console.log('API ERR', e)
    }
  }
  return (
    <Layout>
      <div className="container-schedule-step2">
        <h3>กรุณาเลือกสถานพยาบาล</h3>
        { Array.isArray(HospitalList) && HospitalList.length > 0 ?
          HospitalList.map((item,index) => 
          <div className="hospital-select" key={index} onClick={() => selecthospital(item)}>
            <div className="icon">
              {item.type === "H" ? <Hopital /> : <Factory />}
            </div>
            <h2>{item.name}</h2>
          </div>
        ):
          <div className="hospital-not-found">
            <div className="icon">
              <svg width="64" height="54" viewBox="0 0 64 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M63.2787 21.8152L55.241 17.6667L63.2787 13.5182C63.7188 13.2903 63.9974 12.8384 64 12.3424C64.0027 11.8463 63.7318 11.3906 63.2943 11.1562L43.2943 0.489559C42.9063 0.283809 42.4453 0.281184 42.0547 0.481684L32 5.67131L21.9453 0.481809C21.5546 0.281309 21.0885 0.283934 20.7056 0.489684L0.705647 11.1563C0.268147 11.3907 -0.00272816 11.8464 -0.000103163 12.3426C0.00252184 12.8387 0.281147 13.2904 0.721272 13.5183L8.7589 17.6668L0.721397 21.8152C0.281272 22.0431 0.00264684 22.4949 2.18372e-05 22.9909C-0.00260316 23.4869 0.268272 23.9428 0.705772 24.1772L10.6668 29.4897V41.6668C10.6668 42.1591 10.9376 42.6122 11.3725 42.8439L31.3725 53.5106C31.5679 53.6147 31.784 53.6668 32.0002 53.6668C32.2163 53.6668 32.4324 53.6147 32.6278 53.5106L52.6278 42.8439C53.0627 42.6122 53.3335 42.1591 53.3335 41.6668V29.4897L63.2945 24.1772C63.732 23.9428 64.0029 23.4871 64.0003 22.9909C63.9974 22.4949 63.7188 22.0431 63.2787 21.8152ZM42.6563 3.17193L59.7969 12.3138L52.3335 16.1661L34.9072 7.17181L42.6563 3.17193ZM4.20315 12.3139L21.3438 3.17193L29.0929 7.17181L11.6665 16.1661L4.20315 12.3139ZM4.20315 23.0197L11.6665 19.1674L29.0929 28.1617L21.3438 32.1616L4.20315 23.0197ZM30.6666 50.1106L13.3333 40.8672V30.9118L20.7056 34.8438C20.901 34.9479 21.1171 35.0001 21.3333 35.0001C21.5443 35.0001 21.7525 34.9506 21.9453 34.8516L30.6666 30.3503V50.1106ZM32 26.6612L14.5739 17.6667L32 8.67231L49.4262 17.6668L32 26.6612ZM50.6668 40.8673L33.3334 50.1107V30.3503L42.0548 34.8516C42.2475 34.9506 42.4558 35.0001 42.6668 35.0001C42.8829 35.0001 43.099 34.9479 43.2944 34.8438L50.6668 30.9118V40.8673ZM42.6563 32.1616L34.9072 28.1617L52.3335 19.1674L59.7969 23.0197L42.6563 32.1616Z" fill="white"/>
              </svg>
            </div>
            <h3>ไม่มีข้อมูล</h3>
            <div className="not-found-detail">
              <h5>กรุณาลองใหม่อีกครั้ง</h5>
              <h5>หรือติดติดต่อ xxxxxxxxxx</h5>
            </div>
          </div>
        }
        
      </div>
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state,
  };
};
export default connect(mapStateToProps, actions)(ScheduleStep2);
